import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const resEnvChecklistLivingRoomSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  livingFloor: environmentalChecklistItemWithTicket,
  livingSeating: environmentalChecklistItem,
  livingTable: environmentalChecklistItem,
  livingLight: environmentalChecklistItemWithTicket,
  livingEntertainment: environmentalChecklistItem,
  livingCurtain: environmentalChecklistItemWithTicket,
  livingWindow: environmentalChecklistItemWithTicket,
  livingPicture: environmentalChecklistItem,
  livingComment: z.string().optional(),
});
